/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as createBookmark from './bookmark/createBookmark'
export * as defs from './bookmark/defs'
export * as deleteBookmark from './bookmark/deleteBookmark'
export * as getBookmarks from './bookmark/getBookmarks'
